import { createStore } from 'vuex';
import quotes from './quotes';
import auth from './auth';

export default createStore({
    modules: {
        quotes: quotes,
        auth: auth
    }
});